module.exports = __webpack_public_path__ + "img/Group 97.06245871.svg";